import { DataService } from '../../services/data_service';
import { lazyInject } from '../../services/inversify';
import * as React from 'react';
import { renderText } from '../dateneingabe/assistent/assistent_helpers';
import style from '../../core/import/import_tool.less';
import { ZusatztoolsImportDefinition } from './import/ZusatztoolsImportDefinition';

interface ZusatztoolsImportProps extends React.ClassAttributes<any> {
    data: any;
    modul: string;
    IDs: any;
    entity?: string;
    onFinish?(): void;
    standort?: any;
    whitelistStructures?: Array<string>;
}

interface ZusatztoolsImportState {
    definitions: ReadonlyArray<any>;
    redrawIdx: number;
    importLogData: Array<any>;
}

export class ZusatztoolsImport extends React.Component<ZusatztoolsImportProps, ZusatztoolsImportState> {

    constructor(props: any) {
        super(props);
        this.state = {
            definitions: [],
            redrawIdx: 0,
            importLogData: []
        };
        this.setDefinitions = this.setDefinitions.bind(this);
        this.getImportLogData = this.getImportLogData.bind(this);
    }

    @lazyInject(DataService) private dataService: DataService;

    componentWillMount(): void {
        this.loadDefinitionList();
    }

    getImportLogData(dataIn: any): void {
        const importLogData = dataIn[this.props.IDs.ENT_IMPORT_LOG || null] || [];
        importLogData.forEach((item: any) => item.stamp = item.stamp / 1000);
        this.setState({ importLogData });
    }

    loadDefinitionList(): void {
        this.dataService.loadDataForModul(
            this.props.IDs.ENT_IMPORT_DEFINITIONS, { module: this.props.modul }, { fieldList: 'tid, titel' },
            this.props.modul, this.setDefinitions
        );
    }

    loadImportLogData(): void {
        this.dataService.loadDataForModul(
            this.props.IDs.ENT_IMPORT_LOG, { aktion: 'Datensätze importiert' }, {}, this.props.modul, this.getImportLogData
        );
    }

    render(): JSX.Element {
        return (
            <>
                <div style={{ margin: 5 }}>
                    <span className={style.textmediumbold}>
                        Daten importieren
                    </span>
                    {renderText('Import', this.props.data)}
                </div>
                {this.renderImportProcess()}
            </>
        );
    }

    renderImportProcess(): JSX.Element {
        return (
            <ZusatztoolsImportDefinition
                modul={this.props.modul}
                IDs={this.props.IDs}
                method='new'
                key={`definition_${this.state.redrawIdx}`}
                whitelistStructures={this.props.whitelistStructures}
                initData={{
                    ...(this.props.entity ? { structureKey: this.props.entity } : {}),
                    ...((this.props.standort || {}).name ? { selectedValues: { standort_tid: this.props.standort.name } } : {})
                }}
                onFinish={() => {
                    this.setState({ redrawIdx: this.state.redrawIdx + 1 });
                    this.loadDefinitionList();

                    if (typeof this.props.onFinish === 'function') {
                        this.props.onFinish();
                    }
                }}
            />
        );
    }

    setDefinitions(data: any): void {
        this.loadImportLogData();
        const definitions = data[this.props.IDs.ENT_IMPORT_DEFINITIONS || null] || [];
        this.setState({ definitions });
    }
}
